const GEN_COOKIE_4AI_JS_URI = 'scripts/cookie_4ai.080b3905.js';
const GEN_COOKIE_4AI_CSS_URI = 'styles/cookie/cookie_4ai.a6a5e710.css';
const GEN_BOBBY_JS_URI = 'scripts/bobby.443bbace.js';
const GEN_WEBPUSH_JS_URI = 'scripts/webpush.0cb854f8.js';
const GEN_OFFLINE_JS_URI = 'scripts/offline.22b00d7b.js';

function loadCookieConsent() {
	return new loadExt(
		[assetUrl(GEN_COOKIE_4AI_JS_URI), assetUrl(GEN_COOKIE_4AI_CSS_URI)],
		() => {
			return new cookieConsentJS();
		}
	);
}

function getDefaultsGa() {
	let defaults = {
		dimension1: 'online',
		dimension2: 'proxied',
		// send available width x height (not absolute)
		ScreenResolution: `${window.screen.availWidth}x${window.screen.availHeight}`,
		ViewportSize: `${document.documentElement.clientWidth}x${document.documentElement.clientHeight}`,
		//'DocumentEncoding': document.inputEncoding,
		UserLanguage: navigator.language || navigator.userLanguage,
		DocumentTitle: document.title,
		UserAgentOverride: navigator.userAgent,
		/*
				'PageLoadTime': window.performance.timing.loadEventEnd - window.performance.timing.navigationStart,
				'DnsTime': window.performance.timing.domainLookupEnd - window.performance.timing.domainLookupStart,
				'PageDownloadTime': window.performance.timing.responseEnd - window.performance.timing.requestStart,
				'ServerResponseTime': window.performance.timing.responseStart - window.performance.timing.requestStart,
				'DomInteractiveTime': window.performance.timing.domInteractive - window.performance.timing.navigationStart,
				'SessionControl': undefined,
				'UserTimingCategory': undefined,
				'UserTimingVariableName': undefined,
				'UserTimingTime': undefined,
				'UserTimingLabel': undefined,
				'GeographicalOverride': undefined,
				*/
	};

	// campaign info
	if (location.search) {
		const qs = new URLSearchParams(location.search);
		const keys = {
			utm_id: 'CampaignId',
			utm_source: 'CampaignSource',
			utm_medium: 'CampaignMedium',
			utm_campaign: 'CampaignName',
			utm_term: 'CampaignKeyword',
			utm_content: 'CampaignContent',
		};
		for (const [utmkey, trackkey] of Object.entries(keys)) {
			if (qs.has(utmkey)) {
				defaults[trackkey] = qs.get(utmkey);
			}
		}
	}

	return Object.assign({}, defaults, js_params.bobby_data);
}

function loadBobby() {
	return new loadExt([assetUrl(GEN_BOBBY_JS_URI)], () => {
		gap('send', 'pageview', getDefaultsGa());
	});
}

function loadGoogleAnalytics() {
	/* DEFAULT FROM GOOGLE
		loadExt(['https://www.googletagmanager.com/gtag/js?id=' + js_params.ga_uid + '.js']);
		window.dataLayer = window.dataLayer || [];
		function gtag(){dataLayer.push(arguments);}
		gtag('js', new Date());
		gtag('config', js_params.ga_uid);*/

	window.dataLayer = window.dataLayer || [];
	function gtag() {
		dataLayer.push(arguments);
	}
	gtag('js', new Date());
	return new loadExt(
		['https://www.googletagmanager.com/gtag/js?id=' + js_params.ga_uid + '.js'],
		() => {
			console.debug(
				"GTAG : Google tag manager initié avec l'id suivant : " +
				js_params.ga_uid
			);

			// Test gaData to acknowledge adblocker/anti-tracking usage
			if (window.gaData !== undefined) {
				// Set default value of custom dimension 1 to 'online' (GA4)
				gtag('config', js_params.ga_uid, {
					siteSpeedSampleRate: js_params.siteSpeedSampleRate || 1,
					dimension1: 'online',
				});
			} else {
				// If consent OK but adblocker active, server method triggered
				console.debug('Server hit');
				loadBobby();
			}
		}
	);

	/* OLD
		window.ga = window.ga || function () {
				(ga.q = ga.q || []).push(arguments)
		};
		ga.l = +new Date;
		ga('create', js_params.ga_uid, 'auto', {'siteSpeedSampleRate': js_params.siteSpeedSampleRate || 1});
		// Set default value of custom dimension 1 to 'online'
		ga('set', 'dimension1', 'online');

		return new loadExt([
				'https://www.google-analytics.com/analytics.js'
		], () => {
				console.debug("GA : Google analytics initié avec l'id suivant : " + js_params.ga_uid);
				ga('send', 'pageview');
		})*/
}

function loadWebPush() {
	return new loadExt([assetUrl(GEN_WEBPUSH_JS_URI)], async () => {
		webPushInit();
	});
}

function loadServiceWorker() {
	const env = window.location.host === 'www.artwai.com' ? 'prod' : 'dev';
	return new loadExt(
		[
			assetUrl(`lib/workbox/workbox-window.${env}.umd.js`),
			assetUrl(GEN_OFFLINE_JS_URI),
		],
		async () => {
			if ('serviceWorker' in navigator) {
				const wb = new workbox.Workbox('/workbox_sw.js');

				wb.addEventListener('waiting', () => {
					new createUIPrompt(
						'app-update',
						'La PWA artwai.com doit effectuer une mise à jour.',
						{
							onAccept: async () => {
								wb.messageSW({ type: 'CLEAN_CACHE' });

								wb.addEventListener('controlling', () => {
									window.location.reload();
								});

								wb.messageSW({ type: 'SKIP_WAITING' });
							},
						}
					).show();
				});

				wb.register();
				this.dispatchEvent(
					new CustomEvent('wbregistered', { detail: { workbox: wb } })
				);
			}
		}
	);
}

window.addEventListener('load', async () => {
	if (is_service_worker_enabled()) {
		loadServiceWorker();
	}
});

window.addEventListener('load', async () => {
	if (is_webpush_available()) {
		loadWebPush();
	}
});

window.addEventListener('load', async () => {
	let consentStatsObj = readCookie('consent_statistiques');
	let consentStats = '';
	if (consentStatsObj != false) {
		consentStats = JSON.parse(consentStatsObj);
	}

	if (consentStatsObj === false) {
		loadCookieConsent();
		if (js_params.ga_proxy) {
			loadBobby();
		}
	} else if (consentStats.value !== 1 && js_params.ga_proxy) {
		loadBobby();
	} else if (js_params.ga_enabled) {
		loadGoogleAnalytics();
	}
});

window.addEventListener('load', async () => {
	if (!('indexedDB' in window)) {
		a4ilog.warn(
			"This browser doesn't support IndexedDB. Perfomances may be impacted"
		);
		return;
	}

	const db_name = 'memshare';
	const db_version = 2;

	let idb = window.indexedDB;

	// Open a db instance
	let request = idb.open(db_name, db_version);

	request.onerror = (event) =>
		a4ilog.error('Database error: ' + event.target.errorCode);

	// Create or update the database structure
	request.onupgradeneeded = (event) => {
		const db = event.target.result;

		const offlineStore = db.createObjectStore(db_name, { keyPath: 'key' });
		offlineStore.createIndex('value', 'value');
	};

	request.onsuccess = (event) => {
		// Get db instance
		const db = event.target.result;

		// Open a transaction
		const transaction = db.transaction([db_name], 'readwrite');

		// Select offline-pages object store (table)
		const memshare = transaction.objectStore(db_name);
		const connected = memshare.get('connected');

		connected.onsuccess = () => {
			const connected = document.cookie.search('user_connected') >= 0;
			memshare.put({ key: 'connected', value: connected });
		};
	};
});

document.addEventListener('DOMContentLoaded', async () => {
	const prevArrowHtml = '<button type="button" class="slick-prev arrow--white" title="précédent"><span aria-hidden="true" class="ico" data-ico="chevronleft"></span></button>';
	const nextArrowHtml = '<button type="button" class="slick-next arrow--white" title="suivant"><span aria-hidden="true" class="ico" data-ico="chevronright"></span></button>';

	if (jQuery('.single-programmes .testimonials').length > 0) {
		jQuery('.single-programmes .testimonials').slick({
			dots: false,
			infinite: true,
			speed: 300,
			slidesToShow: 1,
			adaptiveHeight: true,
			variableWidth: false,
			autoplay: true,
			autoplaySpeed: 5000,
			prevArrow:
				'<button type="button" class="slick-prev"><span class="ico" data-ico="chevronleft"></span></button>',
			nextArrow:
				'<button type="button" class="slick-next"><span class="ico" data-ico="chevronright"></span></button>',
		});
	}
	if (jQuery('.sliderImages__slides').length > 0) {
		jQuery('.sliderImages__slides').slick({
			dots: false,
			infinite: true,
			speed: 300,
			slidesToShow: 2,
			adaptiveHeight: false,
			variableWidth: false,
			autoplay: true,
			autoplaySpeed: 5000,
			prevArrow:
				'<button type="button" class="slick-prev"><span class="ico" data-ico="chevronleft"></span></button>',
			nextArrow:
				'<button type="button" class="slick-next"><span class="ico" data-ico="chevronright"></span></button>',
		});
	}
	if (jQuery('.sliderImages_2__slides').length > 0) {
		jQuery('.sliderImages_2__slides').slick({
			dots: false,
			slidesToShow: 1,
			infinite: true,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 768,
					settings: "unslick"
				}
			],
			prevArrow:
				'<button type="button" class="slick-prev arrow-square"><span class="ico" data-ico="chevronleft"></span></button>',
			nextArrow:
				'<button type="button" class="slick-next arrow-square"><span class="ico" data-ico="chevronright"></span></button>',
		});
	}
	if (jQuery('.programme__slider--v2').length > 0) {
		jQuery('.programme__slider--v2').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			infinite: true,
			autoplay: false,
			prevArrow:
				'<button type="button" class="slick-prev arrow-square"><span class="ico" data-ico="chevronleft"></span></button>',
			nextArrow:
				'<button type="button" class="slick-next arrow-square"><span class="ico" data-ico="chevronright"></span></button>',
			mobileFirst: true,
			asNavFor: '.programme__sliderNav--v2',
			responsive: [
				{
					breakpoint: 768,
					settings: {
						arrows: true,
						asNavFor: null,
					}
				}
			]
		});

		jQuery('.programme__sliderNav--v2').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			asNavFor: '.programme__slider--v2',
			arrows: false,
			focusOnSelect: true,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 768,
					settings: "unslick"
				}
			]
		});

		const programmeSliderSlides = jQuery('.programme__slider--v2').attr('data-slides');

		jQuery('.programme__sliderNav--v2 .hero-text-item').on('click', function() {
			const index = jQuery(this).index();
			jQuery('.programme__slider--v2').slick('slickGoTo', index);
		});

		if (programmeSliderSlides > 0 &&
			jQuery('.programme__sliderNav--v2.slick-initialized').length === 0 &&
			jQuery('.hero-text-item').length > 0) {
			for (let i = 0; i < programmeSliderSlides; i++) {
				jQuery('.programme__slider--v2').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
					jQuery('.hero-text-item').each(function () {
						if (jQuery(this).attr('data-image') === '#slide-hero-half-' + nextSlide) {
							jQuery(this).addClass('is-active');
						} else {
							jQuery(this).removeClass('is-active');
						}
					});
				});
			}
		} else if (jQuery('.hero-text-item').length > 0) {
			jQuery('.hero-text-item').removeClass('is-active');
		}

		jQuery('.button-switch, .open-modal').on('click', function () {
			const target = jQuery(this).data('target');
			jQuery('.tab-template').removeClass('active');
			const $tab = jQuery('#' + target).addClass('active');
			$tab.find('.programme__slider--v2').slick('setPosition');
			$tab.find('.programme__sliderNav--v2').slick('setPosition');
		});
	}

	if (jQuery('.single-program .atouts-icons').length > 0 && jQuery('.single-program .atouts-titles').length > 0) {
		jQuery('.single-program .atouts-icons').slick({
			dots: false,
			arrows: false,
			infinite: true,
			speed: 300,
			slidesToShow: 5,
			rows: 1,
			adaptiveHeight: false,
			variableWidth: false,
			centerMode: true,
			asNavFor: '.atouts-titles',
			centerPadding: '0',
			autoplay: true,
			autoplaySpeed: 5000,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 4,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 3,
					},
				},
			],
		});

		jQuery('.single-program .atouts-titles').slick({
			dots: true,
			arrows: false,
			infinite: true,
			speed: 300,
			slidesToShow: 1,
			adaptiveHeight: true,
			variableWidth: false,
			centerMode: true,
			asNavFor: '.atouts-icons',
			centerPadding: '0',
			autoplay: false,
			autoplaySpeed: 5000,
		});
	}

	if (jQuery('.sliderProgrammes__slides').length > 0) {
		jQuery('.sliderProgrammes__slides').slick({
			centerMode: true,
			prevArrow: prevArrowHtml,
			nextArrow: nextArrowHtml,
			centerPadding: '110px',
			responsive: [
				{
					breakpoint: 1400,
					settings: {
						centerPadding: '8%',
					}
				},
			]
		});
	}

	if (jQuery('.programsList__slider').length > 0) {
		jQuery('.programsList__slider').slick({
			slidesToShow: 3,
			infinite: false,
			prevArrow: prevArrowHtml,
			nextArrow: nextArrowHtml,
			responsive: [
				{
					breakpoint: 960,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 575,
					settings: "unslick"
				},
			],
		});
	}

	if (jQuery('.programsList__slider--small').length > 0) {
		jQuery('.programsList__slider--small').slick({
			slidesToShow: 2,
			infinite: false,
			prevArrow: prevArrowHtml,
			nextArrow: nextArrowHtml,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
					}
				}
			],
		});
	}

	jQuery(function ($) {
		const $slider = $('.list-of-post__slider');

		if (
			$slider.length &&
			document.body.contains($slider[0]) &&
			!$slider.hasClass('slick-initialized') &&
			$slider.children().length > 0
		) {
			$slider.slick({
				slidesToShow: 3,
				infinite: false,
				arrows: false,
				accessibility: false,
				prevArrow: prevArrowHtml,
				nextArrow: nextArrowHtml,
				responsive: [
					{
						breakpoint: 1100,
						settings: {
							slidesToShow: 2,
						}
					},
					{
						breakpoint: 650,
						settings: {
							slidesToShow: 1,
							arrows: true,
						}
					},
				],
			});
		}
	});


	if (jQuery('.testimonials-v2').length > 0) {
		jQuery('.testimonials-v2').slick({
			slidesToShow: 3,
			infinite: false,
			prevArrow: prevArrowHtml,
			nextArrow: nextArrowHtml,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						arrows: false,
					}
				},
			],
		});
	}

	jQuery('.filter_tags label[data-button]').on('click', function () {
		let parent = this.closest('.list_of_posts-section');
		const allLink = parent.querySelector('.all-link a');
		const allLinkTitle = allLink.querySelector('.link-title');
		const allLinkIcon = allLink.querySelector('.ico');
		let data = this.getAttribute('data-button');

		if (data === null || allLink === null) {
			return;
		}

		let dataJson = JSON.parse(data);

		if (dataJson.link.title !== null && dataJson.link.title !== '') {
			allLinkTitle.innerText = dataJson.link.title;
		}

		if (dataJson.link.url !== null && dataJson.link.url !== '') {
			allLink.href = dataJson.link.url;
		}

		if (dataJson.icon !== null && dataJson.icon !== '') {
			allLinkIcon.setAttribute('data-ico', dataJson.icon);
		}

		if (dataJson.style !== null && dataJson.style !== '') {
			allLink.classList = dataJson.style;
		}

		if (dataJson.position_icon == 'left') {
			allLink.classList.add('icon-left');
		}
	});

	const tablesResponsive = () => {
		if (jQuery('.zone-content table thead tr').length === 0) {
			return;
		}
		jQuery('.zone-content table thead tr > *').each(function (index) {
			var labelText = jQuery(this).text();
			jQuery('table tbody td:nth-child(' + (index + 1) + ')').attr('data-label', labelText);
			jQuery(this).closest('table').addClass('table-responsive');
		});
	}

	navTabs();
	duplicatedButtonClick();
	customFormMessages();
	customDatepickerDispo();
	tablesResponsive();
});

jQuery('button.open-search-mobile').on('click', function () {
	jQuery(this).parent().addClass('active');
});
jQuery('button.close-search-mobile').on('click', function () {
	jQuery('#filters-archive-programmes-container').removeClass('active');
});

// if we touch outside of #filters-archive-programmes-container and #filters-archive-programmes-container is active, we close it
jQuery(document).on('click', function (e) {
	if (
		jQuery('#filters-archive-programmes-container').hasClass('active') &&
		!jQuery(e.target).closest('#filters-archive-programmes-container').length
	) {
		jQuery('#filters-archive-programmes-container').removeClass('active');
	}
});

document.addEventListener('DOMContentLoaded', () => {
	document.getElementById('openclose-navsite').addEventListener('change', function (e) {
		if (e.target.checked) {
			document.body.classList.add('navsite-open');
		} else {
			document.body.classList.remove('navsite-open');
		}
	});
	document.getElementById('close-all-panels').addEventListener('click', function (e) {
		document.body.classList.remove('navsite-open');
	});
});

// function to manage tabs in content pages
function navTabs() {
	let tabsContainers = document.querySelectorAll('.tabs');

	if (tabsContainers.length === 0) {
		return;
	}

	tabsContainers.forEach((tabsContainer) => {
		let tabsLinks = tabsContainer.querySelectorAll('.nav-link');

		tabsLinks.forEach((tabsLink) => {
			tabsLink.addEventListener('click', function (e) {
				e.preventDefault();
				let target = this.getAttribute('href');
				let parent = this.closest('.tabs');
				let content = parent.querySelector('.tab-content');

				if (target === null || content === null) {
					return;
				}

				let tabContent = content.querySelectorAll('.tab-pane');

				tabContent.forEach((tab) => {
					tab.classList.remove('active');
				});

				tabsLinks.forEach((tab) => {
					tab.classList.remove('active');
					tab.classList.remove('-primary');
					tab.classList.add('-secondary');
				});

				// hide lots that are not related to the tab
				let type = target.replace('#', '');
				let types = ['habiter', 'investir'];
				if (types.includes(type)) {
					let hiddenType = types.filter((item) => item !== type);
					// get duplicated button and apply the same logic
					let duplicatedButtonActive = document.querySelector(
						'.duplicated-button[data-type="' + type + '"]'
					);
					let duplicatedButtonInactive = document.querySelector(
						'.duplicated-button[data-type="' + hiddenType + '"]'
					);

					if (duplicatedButtonActive !== null) {
						duplicatedButtonActive.classList.add('active');
						duplicatedButtonActive.classList.add('-primary');
						duplicatedButtonActive.classList.remove('-secondary');
					}

					if (duplicatedButtonInactive !== null) {
						duplicatedButtonInactive.classList.remove('active');
						duplicatedButtonInactive.classList.remove('-primary');
						duplicatedButtonInactive.classList.add('-secondary');
					}

					const section = this.closest('.ba-section') || document;
					applyLotMode(section, type);
				}

				let tabActive = content.querySelector(target);

				if (tabActive !== null) {
					tabActive.classList.add('active');
				}

				this.classList.remove('-secondary');
				this.classList.add('active');
				this.classList.add('-primary');
			});
		});
	});
}

function duplicatedButtonClick() {
	const buttons = document.querySelectorAll('.duplicated-button');
	if (buttons.length === 0) {
		return;
	}

	buttons.forEach((button) => {
		const realButton = document.querySelector('#' + button.getAttribute('data-type') + '-tab');

		button.addEventListener('click', function (e) {
			e.preventDefault();

			if (realButton !== null) {
				realButton.click();
			}

			buttons.forEach((btn) => {
				btn.classList.remove('active', '-primary');
				btn.classList.add('-secondary');
			});
			this.classList.add('active', '-primary');
			this.classList.remove('-secondary');

			const mode = this.getAttribute('data-type');
			const section = this.closest('.ba-section') || document;
			applyLotMode(section, mode);
		});
	});
}

/**
 * Show/hide individual lots for the given mode and update every group label.
 */
function applyLotMode(section, mode) {
	const hiddenMode = mode === 'habiter' ? 'investir' : 'habiter';

	// Toggle lots flagged for one mode or the other
	section.querySelectorAll('li.lot[data-' + hiddenMode + '="true"]').forEach(lot => {
		lot.style.display = 'none';
	});
	section.querySelectorAll('li.lot[data-' + mode + '="true"]').forEach(lot => {
		lot.style.display = '';
	});

	// Lots flagged invisible for investors are hidden in investir mode and restored in habiter mode
	if (mode === 'investir') {
		section.querySelectorAll('li.lot[data-hide-from-investors]').forEach(lot => {
			lot.style.display = 'none';
		});
	} else {
		// Only restore if not also a pure-investir lot (which stays hidden in habiter mode)
		section.querySelectorAll('li.lot[data-hide-from-investors]:not([data-investir])').forEach(lot => {
			lot.style.display = '';
		});
	}

	// Refresh each group header label and hide groups that have no visible lots
	section.querySelectorAll('.list-appartements > li').forEach(groupLi => {
		updateLotGroupLabel(groupLi, mode);
	});

	// Update individual lot prices (LLI support)
	updateLotPrices(section, mode);

	// Update the hero bloc-contact price
	updateHeroPrice(mode);
}

/**
 * Update the price and TVA badge displayed inside each individual lot row.
 * In investir mode, swaps to data-price-lli and shows tva-badge--lli when available.
 */
function updateLotPrices(section, mode) {
	section.querySelectorAll('li.lot, li.lot-v2').forEach(lot => {
		const valueEl = lot.querySelector('.value[data-price-lli]');
		if (!valueEl) return;

		const targetPrice = mode === 'investir'
			? valueEl.getAttribute('data-price-lli')
			: valueEl.getAttribute('data-price');

		if (targetPrice) {
			// Replace only the leading text node, preserving child elements (e.g. <small>HT</small>)
			for (const node of valueEl.childNodes) {
				if (node.nodeType === Node.TEXT_NODE) {
					node.textContent = targetPrice;
					break;
				}
			}
		}

		if (mode === 'investir') {
			lot.querySelectorAll('.tva-badge:not(.tva-badge--lli)').forEach(b => b.style.display = 'none');
			lot.querySelectorAll('.tva-badge--lli').forEach(b => b.style.display = '');
		} else {
			lot.querySelectorAll('.tva-badge--lli').forEach(b => b.style.display = 'none');
			lot.querySelectorAll('.tva-badge:not(.tva-badge--lli)').forEach(b => b.style.display = '');
		}
	});
}

/**
 * Update all price spans tagged with data-hero-price-{mode} for the current mode.
 * Handles both the hero .bloc-contact and the aside .zone-plaquette spans.
 * When data-link-href is present the price is wrapped in an <a> tag (aside).
 */
function updateHeroPrice(mode) {
	document.querySelectorAll('.prix-min[data-hero-price-' + mode + ']').forEach(priceSpan => {
		const price = priceSpan.getAttribute('data-hero-price-' + mode);
		const tva = priceSpan.getAttribute('data-hero-tva-' + mode);
		const isPrixHt = priceSpan.getAttribute('data-hero-prix-ht') === '1';
		const displayVat = priceSpan.getAttribute('data-hero-display-vat') === '1';
		const linkHref = priceSpan.getAttribute('data-link-href');

		let html = '<span class="a-partir">à partir de</span>';
		if (price) {
			const priceText = price + ' €' + (isPrixHt ? ' <small>HT</small>' : '');
			html += linkHref
				? '<strong><a href="' + linkHref + '">' + priceText + '</a></strong>'
				: '<strong>' + priceText + '</strong>';
			if (displayVat && tva) {
				html += '<span class="tva">(TVA ' + tva + '%)</span>';
			}
		} else {
			const priceText = 'Prix sur demande';
			html += linkHref
				? '<strong><a href="' + linkHref + '">' + priceText + '</a></strong>'
				: '<strong>' + priceText + '</strong>';
		}

		priceSpan.innerHTML = html;
	});
}

/**
 * Refresh the label summary (count, surface, price) for one lot group and
 * hide the group entirely when no lots remain visible.
 */
function updateLotGroupLabel(groupLi, mode) {
	const label = groupLi.querySelector('label.open-list-appartements');
	if (!label) return;

	const visibleLots = Array.from(groupLi.querySelectorAll('li.lot')).filter(
		lot => lot.style.display !== 'none'
	);

	if (visibleLots.length === 0) {
		groupLi.style.display = 'none';
		return;
	}
	groupLi.style.display = '';

	// --- Count ---
	const countValueEl = label.querySelector('.nombre .value');
	if (countValueEl) {
		const rawCount = countValueEl.getAttribute('count-' + mode);
		const count = rawCount !== null ? parseInt(rawCount, 10) : visibleLots.length;
		countValueEl.innerText = count;

		const nombreSpan = countValueEl.closest('.nombre');
		if (nombreSpan) {
			for (const node of nombreSpan.childNodes) {
				if (node.nodeType === Node.TEXT_NODE && node.textContent.includes('disponible')) {
					node.textContent = ' disponible' + (count > 1 ? 's' : '');
					break;
				}
			}
		}
	}

	// --- Surface ---
	updateLotGroupSurface(label, mode);

	// --- Price ---
	updateLotGroupPrice(label, mode);
}

/**
 * Update the surface range displayed in the group label for the current mode.
 * Uses data-surface-min-{mode} / data-surface-max-{mode} stored on the label.
 */
function updateLotGroupSurface(label, mode) {
	if (!label.hasAttribute('data-surface-min-' + mode)) return;

	const surfaceSpan = label.querySelector('.surface');
	if (!surfaceSpan) return;

	const surfMin = parseInt(label.getAttribute('data-surface-min-' + mode), 10) || 0;
	const surfMax = parseInt(label.getAttribute('data-surface-max-' + mode), 10) || 0;
	const tiret = surfaceSpan.previousElementSibling;

	if (!surfMin) {
		surfaceSpan.style.display = 'none';
		if (tiret && tiret.classList.contains('tiret')) tiret.style.display = 'none';
		return;
	}

	surfaceSpan.style.display = '';
	if (tiret && tiret.classList.contains('tiret')) tiret.style.display = '';

	surfaceSpan.innerHTML = surfMax > surfMin
		? 'de <strong>' + surfMin + 'm²</strong> à <strong>' + surfMax + 'm²</strong>'
		: 'de <strong>' + surfMin + 'm²</strong>';
}

/**
 * Update the "à partir de" price displayed in the group label for the current mode.
 * Uses data-price-{mode} (a pre-formatted string) stored on the label.
 * Skips groups with a custom reduction-block price to avoid breaking that display.
 */
function updateLotGroupPrice(label, mode) {
	if (!label.hasAttribute('data-price-' + mode)) return;

	const priceMin = label.querySelector('.prix-min');
	if (!priceMin || priceMin.querySelector('.reduction-block')) return;

	const priceDisplay = label.getAttribute('data-price-' + mode);
	if (priceDisplay) {
		priceMin.innerHTML = '<strong>à partir de&nbsp;</strong><strong>' + priceDisplay + ' €</strong>';
	} else {
		priceMin.innerHTML = '<strong>Prix sur demande</strong>';
	}
}

function customFormMessages() {
	let messagesWeek = document.querySelectorAll('.message-week');
	let messagesWeekEnd = document.querySelectorAll('.message-weekend');

	// if current day is not in the weekend, we hide all message-week and show message-weekend
	let currentDate = new Date();
	let currentDay = currentDate.getDay();
	let isWeekend = currentDay === 0 || currentDay === 6 || currentDay === 5; // include friday as weekend

	messagesWeek.forEach((message) => {
		message.style.display = isWeekend ? 'none' : 'block';
	});
	messagesWeekEnd.forEach((message) => {
		message.style.display = isWeekend ? 'block' : 'none';
	});
}

function getJoursFeries(year) {
	let bankHolidays = [
		`${year}-01-01`, // Jour de l'an
		`${year}-05-01`, // Fête du travail
		`${year}-05-08`, // Victoire 1945
		`${year}-07-14`, // Fête nationale
		`${year}-08-15`, // Assomption
		`${year}-11-01`, // Toussaint
		`${year}-11-11`, // Armistice 1918
		`${year}-12-25`, // Noël
	];

	bankHolidays = bankHolidays.map((date) => new Date(date));

	// Calcul de la date de Pâques
	const easterDate = calculateEaster(year);

	// Ajout des jours fériés liés à Pâques
	bankHolidays.push(easterDate); // Pâques
	bankHolidays.push(addDays(easterDate, 1)); // Lundi de Pâques
	bankHolidays.push(addDays(easterDate, 39)); // Ascension

	// On ne renvoie pas la Pentecôte parce qu'on travaille :'(
	// bankHolidays.push(formatDate(addDays(easterDate, 50))); // Pentecôte

	return bankHolidays;
}

// Fonction pour calculer la date de Pâques (algorithme de Meeus/Jones/Butcher)
function calculateEaster(year) {
	const a = year % 19;
	const b = Math.floor(year / 100);
	const c = year % 100;
	const d = Math.floor(b / 4);
	const e = b % 4;
	const f = Math.floor((b + 8) / 25);
	const g = Math.floor((b - f + 1) / 3);
	const h = (19 * a + b - d - g + 15) % 30;
	const i = Math.floor(c / 4);
	const k = c % 4;
	const l = (32 + 2 * e + 2 * i - h - k) % 7;
	const m = Math.floor((a + 11 * h + 22 * l) / 451);
	const month = Math.floor((h + l - 7 * m + 114) / 31);
	const day = ((h + l - 7 * m + 114) % 31) + 1;

	return new Date(year, month - 1, day); // Mois en JavaScript : 0-indexé
}

// Fonction pour ajouter des jours à une date
function addDays(date, days) {
	const result = new Date(date);
	result.setDate(result.getDate() + days);
	return result;
}

function customDatepickerDispo() {
	let dateInputs = document.querySelectorAll('.date-disponibilite');

	if (dateInputs.length === 0) {
		return;
	}

	dateInputs.forEach((input) => {
		// heure input is a selected field (options are "9h00" "9h30" "10h00" "10h30" "11h00" "11h30" "12h00" "12h30" "13h00" "13h30" "14h00" "14h30" "15h00" "15h30" "16h00" "16h30" "17h00" "17h30" "18h00" "18h30" "19h00" "19h30")
		const heureInput = input.parentNode.parentNode.parentNode.querySelector(
			'.heure-disponibilite'
		);

		// use https://github.com/qodesmith/datepicker
		const picker = datepicker(input, {
			format: 'dd/mm/yyyy',
			formatter: (input, date, instance) => {
				input.value = date.toLocaleDateString();
			},
			minDate: new Date(),
			maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
			autoClose: true,
			inline: true,
			disabler: (date) => date.getDay() === 0 || date.getDay() === 6,
			customDays: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
			customMonths: [
				'Janvier',
				'Février',
				'Mars',
				'Avril',
				'Mai',
				'Juin',
				'Juillet',
				'Août',
				'Septembre',
				'Octobre',
				'Novembre',
				'Décembre',
			],
			disabledDates: [
				...getJoursFeries(new Date().getFullYear()),
				...getJoursFeries(new Date().getFullYear() + 1),
				new Date(),
			],
			startDay: 1,
			position: 'bl',
			zIndex: 1000,
			onSelect: (instance, date) => {
				let selectedDay = date.getDay();
				let selectedHour = heureInput.value;
				let options = heureInput.querySelectorAll('option');

				let disabledDates = getJoursFeries(new Date().getFullYear());

				let isAfterDisabled = false;
				disabledDates.forEach((disabledDate) => {
					let nextDate = new Date(disabledDate);
					nextDate.setDate(disabledDate.getDate() + 1);
					if (
						nextDate.getDate() === date.getDate() &&
						nextDate.getMonth() === date.getMonth()
					) {
						isAfterDisabled = true;
					}

					if (isAfterDisabled) {
						return;
					}
				});

				options.forEach((option) => {
					// create date from option value
					let date = new Date();
					let hour = option.value.split('h');
					date.setHours(hour[0]);
					date.setMinutes(hour[1]);
					date.setSeconds(0);

					let now = new Date();

					option.removeAttribute('disabled');

					// if it is 17h30 and selected date is tomorrow (today+1 day), disable all options before 10h30
					if (now.getHours() > 17 && selectedDay === now.getDate() + 1) {
						if (
							date.getHours() < 10 ||
							(date.getHours() === 10 && date.getMinutes() < 30)
						) {
							option.setAttribute('disabled', 'disabled');
							if (option.value === selectedHour) {
								option.removeAttribute('selected');
								heureInput.value = '10h30';
							}
						}
					}



					// if selected date is monday or after disabled, limite options from 13h to 19h30
					if (selectedDay === 1 || isAfterDisabled) {
						if (
							date.getHours() < 13 ||
							(date.getHours() === 13 && date.getMinutes() < 0) ||
							date.getHours() > 19 ||
							(date.getHours() === 19 && date.getMinutes() > 30)
						) {
							option.setAttribute('disabled', 'disabled');
							if (option.value === selectedHour) {
								option.removeAttribute('selected');
								heureInput.value = '13h00';
							}
						}
					}
				});
			},
		});
	});
}

document.addEventListener('DOMContentLoaded', () => {
    const geoItems = document.querySelectorAll('.geographical-location-interest-item');
    const geoItemsList = document.querySelectorAll('.geographical-location-interest-item-liste');
    const geoItemsTitle = document.querySelectorAll('.geographical-location-interest-item-titre');

    geoItems.forEach((item, index) => {
        item.addEventListener('click', () => {

            const isActive = geoItemsList[index].classList.contains('active');
            geoItemsList.forEach(list => {
                list.classList.remove('active');
            });

            geoItemsTitle.forEach(title => {
                title.classList.remove('active');
            });

            if (!isActive) {
                geoItemsList[index].classList.add('active');
                geoItemsTitle[index].classList.add('active');
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const wrapper = document.getElementById('wrapper');
    const anchorsMenu = document.querySelector('.anchors-menu-container');

    if (!wrapper || !anchorsMenu) return;

    let lastScrollTop = 0;
    const threshold = 10;

    window.addEventListener('scroll', () => {
        const currentScroll =
            window.pageYOffset || document.documentElement.scrollTop;

        if (Math.abs(currentScroll - lastScrollTop) < threshold) {
            return;
        }

        if (currentScroll <= 100) {
            wrapper.classList.remove('header-is-hidden');
            anchorsMenu.classList.remove('menu-up');
        } else if (currentScroll > lastScrollTop) {
            wrapper.classList.add('header-is-hidden');
            anchorsMenu.classList.add('menu-up');
        } else {
            wrapper.classList.remove('header-is-hidden');
            anchorsMenu.classList.remove('menu-up');
        }

        lastScrollTop = Math.max(currentScroll, 0);
    });
});

document.addEventListener('DOMContentLoaded', () => {
	const lotsContainer = document.querySelector('div#biens');
    const filterContainer = document.querySelector('.nav-pills-v2');
	const tvaByType = {
		brs: '5.5',
		'libre-jeanbrun': '20',
		'jeanbrun-lli': '10',
		tva_55: '5.5'
	};

    if (!filterContainer) {
        return;
    }

	const htPricesShown = lotsContainer && lotsContainer.classList.contains('prix-ht');

    const buttons = filterContainer.querySelectorAll('button[data-type]');
    const lots = document.querySelectorAll('li.lot-item');
    const groups = document.querySelectorAll('.lot-group');

    if (!buttons.length || !lots.length) {
        return;
    }

    function updateCounters() {
        groups.forEach(group => {
            const visibleLots = group.querySelectorAll(
                'li.lot-item:not([style*="display: none"])'
            );

            const count = visibleLots.length;

            const valueEl = group.querySelector('.nombre .value');
            const labelEl = group.querySelector('.label-disponible');

            if (!valueEl || !labelEl) {
                return;
            }

            valueEl.textContent = count;
            labelEl.textContent =
                count > 1 ? 'disponibles' : 'disponible';

            group.style.display = count ? '' : 'none';

			const priceMinEl = group.querySelector('.prix-min');
			if (priceMinEl && !priceMinEl.querySelector('.reduction-block') && count > 0) {
				let minPrice = null;
				visibleLots.forEach(lot => {
					const priceEl = htPricesShown ? 
						lot.querySelector('.value[data-price-ht]') : 
						lot.querySelector('.value[data-price]');
					if (priceEl && ((htPricesShown && priceEl.dataset.priceHt) || (!htPricesShown && priceEl.dataset.price))) {
						const price = htPricesShown ? 
							parseFloat(priceEl.dataset.priceHt.replace(/\s/g, '')) : 
							parseFloat(priceEl.dataset.price.replace(/\s/g, ''));
						if (minPrice === null || price < minPrice) {
							minPrice = price;
						}
					}
				});

				if (minPrice !== null) {
					const formattedPrice = Math.round(minPrice).toLocaleString('fr-FR');
					priceMinEl.innerHTML = '<strong>à partir de&nbsp;</strong><strong>' + formattedPrice + ' €</strong>';
					if(htPricesShown) {
						priceMinEl.innerHTML += ' <small>HT</small>';
					}
				} else {
					priceMinEl.innerHTML = '<strong>Prix sur demande</strong>';
				}
			}
		});
    }

    buttons.forEach(button => {
        button.addEventListener('click', () => {
            const type = button.dataset.type;

            if (!type) {
                return;
            }

            buttons.forEach(btn => {
                btn.classList.remove('active');
            });

            button.classList.add('active');

            lots.forEach(lot => {
				const lotTypes = lot.dataset.types;
                if (!lotTypes && type !== 'all') {
                    lot.style.display = 'none';
                    return;
                }

				if(lotTypes.split(' ').includes(type) || type === 'all') {
					lot.style.display = '';

					const tvaElement = lot.querySelector('.lot-tva');
					if (!tvaElement) {
						return;
					}

					let tva;
					if (type === 'all') {
						// TVA d'origine du BO
						tva = tvaElement.dataset.defaultTva;
					} else {
						tva = tvaByType[type];
					}

					if (tva) {
						tvaElement.textContent = `TVA ${tva}%`;
						tvaElement.className = `xs tva-badge lot-tva tva-badge--${tva.replace('.', '-')}`;

						if(!htPricesShown) {
							const priceEl = lot.querySelector('.value[data-price]');
							const priceHT = priceEl ? priceEl.dataset.priceHt : null;

							if (priceHT) {
								const priceTTC = (parseFloat(priceHT) * (1 + parseFloat(tva) / 100)).toFixed(0);
								priceEl.textContent = `${parseInt(priceTTC).toLocaleString('fr-FR')} €`;
								priceEl.dataset.price = priceTTC;
							}
						}
					}
				} else {
					lot.style.display = 'none';
				}
            });

            updateCounters();
        });
    });

});